import { useState } from 'react';
import { useDispatch } from 'react-redux';
import LogoutSVG from '../../assets/svgs/Logout.svg';

import classes from './SiderElement.module.scss';
import { authAction } from '../../store/auth-slice';
import YesNoSection from './YesNoSection';

export default function Logout({ text, t, language }) {
  const dispatch = useDispatch();
  const [askForLogoutSectionIsVisible, setAskForLogoutSectionIsVisible] =
    useState(false);

  const logoutHandler = () => {
    dispatch(authAction.logout());
  };

  const showForLogout = () => {
    setAskForLogoutSectionIsVisible(true);
  };
  return (
    <>
      {askForLogoutSectionIsVisible && (
        <YesNoSection
          logoutFn={logoutHandler}
          setModalHidden={() => setAskForLogoutSectionIsVisible(false)}
          t={t}
          language={language}
        />
      )}
      <div
        className={`${classes.link} ${classes[language]}`}
        onClick={showForLogout}
      >
        <span>
          <img src={LogoutSVG} alt={text} className={classes.icon} />
        </span>
        <span className={classes['link-text']}>{t(text)}</span>
      </div>
    </>
  );
}
